/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import "./FeaturesSlider.css";

import { Navigation, Pagination, Parallax, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";
import FeaturedBooks from "./FeaturedBooks";
import Updates from "./Updates";

const FeaturesSlider = () => {
  //builders

  return (
    <div className="feature-slider">
      <Swiper
        spaceBetween={30}
        navigation={true}
        parallax={true}
        pagination={{
          clickable: true,
        }}
        autoplay={{
          delay: 3500,
          disableOnInteraction: true,
        }}
        modules={[Navigation, Pagination, Parallax, Autoplay]}
        className="features-swiper"
      >
        <div
          slot="container-start"
          className="parallax-bg"
          data-swiper-parallax="-23%"
        ></div>
        <SwiperSlide>
          <div className="features-slider-item">
            <FeaturedBooks />
          </div>
        </SwiperSlide>
        {/* <SwiperSlide>
          <div className="features-slider-item">
            <FeaturedAuthors />
          </div>
        </SwiperSlide> */}
        <SwiperSlide>
          <div className="features-slider-item">
            <Updates />
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default FeaturesSlider;
